import React, { Fragment } from 'react'
import { Segment, Button, Divider, Image } from 'semantic-ui-react'
import { getAuthor } from './utils'
import './story-about-screen.css'
import Logo from './logo.svg'

const StoryAboutScreen = (props) => {
  const {
    story,
    onClose
  } = props

  const { name, description, image } = story.meta

  return (
    <Segment className='story-about-screen' inverted padded='very' style={{ width: 350, padding: '2.5em 3em'}}>
      <Button primary circular icon='close' onClick={onClose} style={{ position: 'absolute', top: 10, right: 10 }} />
      <Fragment>
        <div style={{ fontStyle: 'italic' }}>Moiki présente</div>
        <h2 style={{ marginBottom: '0.1em', marginTop: '0.1em' }}>{ name }</h2>
        <div style={{ fontStyle: 'italic', color: '#9e9a9a', marginBottom: '1em' }}>Une histoire de { getAuthor(story.meta) }</div>
        { image && (
          <Image style={{maxHeight: 225, overflow: 'hidden'}} wrapped ui={false}>
            <div className='cover' style={{ backgroundImage: 'url(' + image + ')' }} />
          </Image>
        )}
        <p style={{ marginTop: '0.3em' }}>{ description }</p>
        <div style={{ display: 'flex', justifyContent: 'space-around', color: '#878787' }}>
          <img src={Logo} style={{ width: 50, height: 50 }} />
          <p><em><a href="https://moiki.fr" target="_blank" rel="noreferrer noopener">Moiki.fr</a> est une plateforme gratuite permettant de créer des histoires à embranchements.</em></p>
        </div>
       </Fragment>
    </Segment>
  )
}

export default StoryAboutScreen